import { render, staticRenderFns } from "./BlessingBagItem.vue?vue&type=template&id=cdf59072&scoped=true"
import script from "./BlessingBagItem.vue?vue&type=script&lang=js"
export * from "./BlessingBagItem.vue?vue&type=script&lang=js"
import style0 from "./BlessingBagItem.vue?vue&type=style&index=0&id=cdf59072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf59072",
  null
  
)

export default component.exports